import { Route, Routes } from "react-router-dom";
import Layout from "./layout";
import Home from "../components/home/home.jsx";
import Service from "../pages/service/service.jsx";
import AirTransportation from "../pages/service/airTransportation.jsx";
import LandTransportation from "../pages/service/landTransportation/landTransportation.jsx";
import ShipRental from "../pages/service/shipRental/shipRental.jsx";
import DangerousGoods from "../pages/service/dangerousGoods/dangerousGoods.jsx";
import CustomsClearance from "../pages/service/customerClearance/customerClearance.jsx";
import PartialTransport from "../pages/service/partialTransport/partialTransport.jsx";
import Caching from "../pages/service/caching/caching.jsx";
import ProductionLogistics from "../pages/service/productionLogistics/productionLogistics.jsx";
import TrainShipping from "../pages/service/trainShipping/trainShipping.jsx";
import OfferPrice from "../pages/offerPrice/offerPrice.jsx";
import AboutUs from "../pages/aboutUs/aboutUs.jsx";
import Blog from "../pages/blog/blog.jsx";
import ContactUs from "../pages/contactUs/contactUs.jsx";
import FaQs from "../pages/faqs/faqs.jsx";
import Terms from "../pages/Terms/Terms.jsx";
import Privacy from "../pages/privacy/privacy.jsx";
import Tools from "../pages/tools/tools.jsx";
import Blogs from "../pages/blogs/blogs.jsx";
import BlogPage from "../pages/blogPage/blog.jsx";
import CustomTariffs from "../pages/tools/customTariffs/customTariffs.jsx";
import CustomDuty from "../pages/tools/customDuty/customDuty.jsx";
import CustomClearanceTool from "../pages/tools/customClearance/customClearance.jsx";
import ContainerTypes from "../pages/tools/containerTypes/containerTypes.jsx";
import TruckType from "../pages/tools/truckTypes/truckTypes.jsx";
import InternationalTrade from "../pages/tools/internationalTrade/internationalTrade.jsx";
import ShippingCalculator from "../pages/tools/shipppingCalucaltor/shipppingCalculator.jsx";
import MarinContainers from "../pages/marinContainers/marinContainers.jsx";
import EmployeeDashboardLayout from "./employeeDashboardLayout.jsx";
import EmployeesHome from "../pages/dashboard/employeesBoard/home/employeesHome.jsx";
import Shipments from "../pages/dashboard/employeesBoard/shipments/shipments.jsx";
import RequestsReplies from "../pages/dashboard/employeesBoard/requestsReplies/requestsReplies.jsx";
import Notifications from "../pages/dashboard/employeesBoard/notifications/notifications.jsx";
import RequestOfferPrice from "../pages/dashboard/employeesBoard/offerPrice/requestOfferPrice.jsx";
import Settings from "../pages/dashboard/employeesBoard/settings/settings.jsx";
import ShipmentDetail from "../pages/dashboard/employeesBoard/shipments/shipmentDetails.jsx";
import AgentDashboardLayout from "./agentDashboardLayout.jsx";
import AgentHome from "../pages/dashboard/agentBoard/home/agentHome.jsx";
import AgentShipments from "../pages/dashboard/agentBoard/shipments/shipments.jsx";
import IssueBillLading from "../pages/dashboard/agentBoard/billLading/issueBilllLading.jsx";
import ShipmentTracking from "../pages/dashboard/agentBoard/shipmentTracking/shipmentTracking.jsx";
import Employees from "../pages/dashboard/agentBoard/employees/employees.jsx";
import AgentSettings from "../pages/dashboard/agentBoard/settings/settings.jsx";
import Requests from "../pages/dashboard/agentBoard/requests/requests.jsx";
import Messages from "../pages/dashboard/agentBoard/messages/messages.jsx";
import VisualIdentity from "../pages/dashboard/agentBoard/visualIdentity/visualIdentity.jsx";
import OffersAndPrices from "../pages/dashboard/agentBoard/offersAndPrices/offersAndPrices.jsx";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import SignIn from "../pages/auth/auth.jsx";
import SeaShipping from "../pages/seaShipping/seaShipping.jsx";
const Routers = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/auth" element={<SignIn />} />
          <Route path="/services" element={<Service />} />
          <Route path="/offer-price" element={<OfferPrice />} /> {/* OfferPrice */}
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/bloog" element={<Blog />} />
          <Route path="/contact-us" element={<ContactUs />} /> {/* ContactUs */}
          <Route path="/FAQs" element={<FaQs />} />
          <Route path="/terms-&-conditions" element={<Terms />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogPage />} />
          <Route path="/container-sizes" element={<MarinContainers />} />
          <Route path="/tools/customs-tariffs" element={<CustomTariffs />} />
          <Route path="/tools/customs-duty" element={<CustomDuty />} />
          <Route path="/tools/customs-clearance" element={<CustomClearanceTool />} />
          <Route path="/tools/container-types" element={<ContainerTypes />} />
          <Route path="/tools/truck-types" element={<TruckType />} />
          <Route path="/tools/international-terms" element={<InternationalTrade />} />
          <Route path="/tools/shipping-calculators" element={<ShippingCalculator />} />
          <Route path="/services/air-transportation" element={<AirTransportation />} />
          <Route path="/services/sea-transportation" element={<SeaShipping />} />
          <Route
            path="/services/land-transportation"
            element={<LandTransportation />}
          />
          <Route path="/services/ship-rental" element={<ShipRental />} />
          <Route path="/services/dangerous-goods" element={<DangerousGoods />} />
          <Route path="/services/customs-clearance" element={<CustomsClearance />} />
          <Route path="/services/partial-transport" element={<PartialTransport />} />
          <Route path="/services/caching" element={<Caching />} />
          <Route path="/services/train-transportation" element={<TrainShipping />} />
          <Route
            path="/services/production-logistics"
            element={<ProductionLogistics />}
          />
        </Route>
        <Route path="/employee/dashboard" element={<EmployeeDashboardLayout />}>
          <Route index element={<EmployeesHome />} />
          <Route path="/employee/dashboard/shipments" element={<Shipments />} />
          <Route
            path="/employee/dashboard/shipments/:id"
            element={<ShipmentDetail />}
          />
          <Route path="/employee/dashboard/notifications" element={<Notifications />} />
          <Route
            path="/employee/dashboard/offer-price"
            element={<RequestOfferPrice />}
          />
          <Route path="/employee/dashboard/settings" element={<Settings />} />
          <Route
            path="/employee/dashboard/request-replies"
            element={<RequestsReplies />}
          />
        </Route>
        <Route path="/agent/dashboard" element={<AgentDashboardLayout />}>
          <Route index element={<AgentHome />} />
          <Route path="/agent/dashboard/shipments" element={<AgentShipments />} />
          <Route
            path="/agent/dashboard/track-shipments"
            element={<ShipmentTracking />}
          />
          <Route
            path="/agent/dashboard/issue-bill-of-lading"
            element={<IssueBillLading />}
          />
          <Route path="/agent/dashboard/settings" element={<AgentSettings />} />
          <Route path="/agent/dashboard/employees" element={<Employees />} />
          <Route path="/agent/dashboard/requests" element={<Requests />} />
          <Route path="/agent/dashboard/messages" element={<Messages />} />
          <Route path="/agent/dashboard/visual-identity" element={<VisualIdentity />} />
          <Route
            path="/agent/dashboard/offers-and-prices"
            element={<OffersAndPrices />}
          />
        </Route>
      </Routes>
    </>
  );
};

export default Routers;
